export default {
  namespaced: true,
  state: {
    overlay: false,
    clients: [],
    clientsMap: {},
    user: {}
  },
  getters: {
    getOverlay: state => state.overlay,
    getClients: state => state.clients,
    getClientsMap: state => state.clientsMap,
    getUser: state => state.user
  },
  mutations: {
    setOverlay: (state, overlay) => {
      state.overlay = overlay;
    },
    setClients: (state, clients) => {
      state.clients = clients
      const map = {}
      clients.forEach(client => {
        map[client.id] = client
      })
      state.clientsMap = map
    },
    setUser: (state, user) => {
      user['rolesMap'] = user.roles.reduce(function (map, obj) {
        map[obj] = true;
        return map;
      }, {});

      state.user = user;
    }
  },
  actions: {
    setOverlay({commit}, overlay) {
      commit('setOverlay', overlay);
    },
    setUser({commit}, user) {
      commit('setUser', user);
    },
    initStore({commit}, data) {
      if (data !== undefined) {
        commit('setUser', data['user']);
        if(data['clients']){
          commit('setClients', data['clients']);
        }
      } else {
        this._vm.xAjax({
          url: '/base/users/me'
        }).then(resp => {
          commit('setUser', resp);
        })
      }

      //this.$store.dispatch('base/getUser', '112121'); 로 호출가능
      //store 내에서는 this._vm으로 vm 접근 가능
    }
  }
};
